const isDevHost = window.location.host.indexOf("localhost") > -1;

const ENABLE_CALLS = isDevHost;
const ENABLE_KB = isDevHost;

const ENABLE_MAILBOXES = isDevHost;
const ENABLE_TICKETS = isDevHost;

export { ENABLE_CALLS, ENABLE_KB, ENABLE_MAILBOXES, ENABLE_TICKETS };
